import { Component, inject } from '@angular/core';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MenuComponent } from '../../components/Controls/menu/menu.component';
import { PgfPieComponent } from './pie/pie.component';
import { PgfHowItWorksComponent } from './how-it-works/how-it-works.component';
import { RouterLink } from '@angular/router';
import { NewsComponent } from '../../components/Controls/News/news.component';
import { AdvisorContactComponent } from '../shared/advisor-contact.component';

@Component({
    templateUrl: './pgf-intro.component.html',
    styleUrls: ['pgf-intro.component.scss'],
    imports: [MenuComponent, PgfPieComponent, PgfHowItWorksComponent, RouterLink, NewsComponent, AdvisorContactComponent]
})
export class PgfIntroComponent {
  modalService = inject(NgbModal);
}